module.exports = __webpack_public_path__ + "img/hb-bottom.eaea23ab.png";